import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ComplianceTrend.module.css';

const STATUS_COLOR = {
  PASS: 'var(--green)',
  WARN: 'var(--amber)',
  FAIL: 'var(--red)',
};

function RatioCell({ value, status }) {
  const color = STATUS_COLOR[status] || 'var(--text-dim)';
  return (
    <td className={styles.ratioCell} style={{ color }}>
      {value !== null ? value + '%' : '—'}
    </td>
  );
}

export default function ComplianceTrend({ trend }) {
  const { t } = useTranslation();
  if (!trend || trend.length < 2) return null;

  return (
    <div className={styles.wrap}>
      <p className={styles.label}>{t('compliance_trend.label')}</p>
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>{t('compliance_trend.table.year')}</th>
              <th>{t('compliance_trend.table.debt_assets')}</th>
              <th>{t('compliance_trend.table.haram_rev')}</th>
              <th>{t('compliance_trend.table.illiquid_assets')}</th>
              <th>{t('compliance_trend.table.verdict')}</th>
            </tr>
          </thead>
          <tbody>
            {trend.map((row) => (
              <tr key={row.period} className={row.isCurrent ? styles.currentRow : ''} data-verdict={row.overallVerdict}>
                <td className={styles.yearCell}>
                  {row.year || row.period}
                </td>
                <RatioCell value={row.debtRatio}     status={row.debtStatus} />
                <RatioCell value={row.haramRatio}    status={row.haramStatus} />
                <RatioCell value={row.illiquidRatio} status={row.illiquidStatus} />
                <td>
                  <span
                    className={styles.verdictPill}
                    data-verdict={row.overallVerdict}
                  >
                    {t(`compliance_trend.verdict.${row.overallVerdict}`) || row.overallVerdict}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className={styles.footnote}>{t('compliance_trend.footnote')}</p>
    </div>
  );
}
